"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var Divider = function Divider(_ref) {
  var vertical = _ref.vertical,
      theme = _ref.theme,
      style = _ref.style;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  return _react["default"].createElement(_root["default"], {
    vertical: vertical,
    theme: memoTheme
  });
};

Divider.propTypes = {
  vertical: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.elDivider
     */
    background: _propTypes["default"].string,

    /**
     * @default 100%
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 1px
     */
    height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
};
var _default = Divider;
exports["default"] = _default;